export const ID_TO_SEND = "TO_SEND";
export const ID_PUBLISHED = "PUBLISHED";
export const ID_PROCESSING = "PROCESSING";
export const ID_ERROR = "ERROR";